import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

// Mock permission options for demonstration
const PERMISSION_OPTIONS = [
  "Search",
  "Free CMS",
  "About Us",
  "Advertise Us",
  "Parent Page",
  "Favorites",
  "Members",
  "Login",
  "My Profile",
  "Registration",
  "Blog",
  "Tag Management",
  "Blog Archive",
  "Blog Edit",
  "Blog Add",
  "Blog Remove",
];

// Simulate fetching data
const fetchRoleById = (id) => {
  const roles = [
    {
      id: 1,
      name: "Admin",
      description: "Administrator",
      permissions: [
        "Search",
        "Free CMS",
        "About Us",
        "Advertise Us",
        "Parent Page",
        "Favorites",
        "Members",
        "Login",
        "My Profile",
        "Registration",
        "Blog",
        "Tag Management",
        "Blog Archive",
        "Blog Edit",
        "Blog Add",
        "Blog Remove",
      ],
      active: true,
    },
    {
      id: 2,
      name: "Author",
      description: "Content Author",
      permissions: ["Submit Articles", "Edit Own Articles"],
    },
    {
      id: 3,
      name: "Distributor",
      description: "Content Distributor",
      permissions: ["Distribute Articles", "Manage Distribution"],
    },
    {
      id: 4,
      name: "User",
      description: "Regular User",
      permissions: ["View Content"],
    },
  ];
  return roles.find((role) => role.id === parseInt(id)) || { permissions: [] };
};

const RoleEditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [role, setRole] = useState({
    name: "",
    description: "",
    permissions: [],
    active: true,
  });
  const [permissionsState, setPermissionsState] = useState({});

  useEffect(() => {
    const fetchedRole = fetchRoleById(id);
    setRole(fetchedRole);

    // Initialize permissions state after role is fetched
    const initialPermissionsState = PERMISSION_OPTIONS.reduce(
      (acc, permission) => {
        acc[permission] = fetchedRole.permissions.includes(permission)
          ? "Yes"
          : "No";
        return acc;
      },
      {}
    );
    setPermissionsState(initialPermissionsState);
  }, [id]);

  const handleSave = (e) => {
    e.preventDefault();
    // Implement save logic
    console.log("Role saved:", role);
    navigate("/admin/role-management");
  };

  const handlePermissionChange = (permission, value) => {
    setPermissionsState((prevState) => {
      const newState = { ...prevState, [permission]: value };
      setRole((prevRole) => ({
        ...prevRole,
        permissions: Object.keys(newState).filter(
          (perm) => newState[perm] === "Yes"
        ),
      }));
      return newState;
    });
  };

  return (
    <div className="bg-white p-4 mb-3">
      <h3>{role.id ? "Edit Role" : "Add Role"}</h3>
      <form onSubmit={handleSave}>
        <div className="mb-3">
          <label className="form-label fs-6 fw-bold">Role Name</label>
          <input
            type="text"
            className="form-control"
            value={role.name}
            onChange={(e) => setRole({ ...role, name: e.target.value })}
          />
        </div>
        <div className="mb-3">
          <label className="form-label fs-6 fw-bold">Description</label>
          <input
            type="text"
            className="form-control"
            value={role.description}
            onChange={(e) => setRole({ ...role, description: e.target.value })}
          />
        </div>
        <div className="mb-3">
          <label className="form-label fs-6 fw-bold">Permissions</label>
          <div>
            {PERMISSION_OPTIONS.map((permission) => (
              <div key={permission} className="mb-2 d-flex align-items-center">
                <label className="form-label w-25">{permission}</label>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id={`${permission}-yes`}
                    name={permission}
                    value="Yes"
                    checked={permissionsState[permission] === "Yes"}
                    onChange={() => handlePermissionChange(permission, "Yes")}
                    className="form-check-input"
                  />
                  <label
                    htmlFor={`${permission}-yes`}
                    className="form-check-label me-2"
                  >
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id={`${permission}-no`}
                    name={permission}
                    value="No"
                    checked={permissionsState[permission] === "No"}
                    onChange={() => handlePermissionChange(permission, "No")}
                    className="form-check-input"
                  />
                  <label
                    htmlFor={`${permission}-no`}
                    className="form-check-label"
                  >
                    No
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
        <Button type="submit" className="btn btn-dark">
          Save
        </Button>
        <Button
          type="button"
          className="btn btn-outline-secondary ms-2"
          onClick={() => navigate("/admin/role-management")}
        >
          Cancel
        </Button>
      </form>
    </div>
  );
};

export default RoleEditPage;
